// src/components/settings/Settings.tsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import IssuesLoader from '../issues/IssuesLoader';
import { useIssuesCache } from '../../contexts/IssuesCacheContext';
import './Settings.css'; // Styles for Settings page

const ISSUES_PREFIX_PATH = "https://github.com/zignals/c-breadcrumbai/issues";
// "https://github.com/funmu/sigwatch-pinpoint/issues";

const Settings: React.FC = () => {
  const { issues, setIssues } = useIssuesCache(); // Get the function to update issues in context
  const [ fileSource, setFileSource ] = useState<string | null>(null); // Get the function to update issues in context

  // Callback to handle loaded issues from IssuesLoader
  const handleIssuesLoaded = (file: File, loadedIssues: any[]) => {
    // console.log("Issues loaded in Settings:", loadedIssues.length);
    setIssues(loadedIssues); // Update the global issues state
    setFileSource(file.name);
    // Optionally, add user feedback like a success message
  };

  return (
    <div className="settings-page">
      <h2>Settings</h2>

      <section className="settings-section">

        <div className="issues-source-setting">
          {/* Render the loaded informaion, 
          ToDo: keep track of history of loaded issues
           */}
          <div className="issues-source-loaded">
            { (fileSource && issues && issues.length > 0) && 
              (
              <div className="space-x-8 justify-center"> {/* Centered buttons */}
                <p>Loaded <span className='font-semibold'>{issues?.length}</span> Issues 
                  from <span className='font-semibold'>{fileSource}</span></p>
                <div>
                <Link to="/issues/someTeamId" className="deriq-action-button"> {/* Update teamId if needed */}
                  Go to Issues
                </Link>
                </div>
              </div>
              )}
          </div>

          <div className="issues-source-setting-loader">
          {/* Render the IssuesLoader, passing the handler */}
            <IssuesLoader 
              linkPrefix={ISSUES_PREFIX_PATH} 
              onIssuesLoaded={handleIssuesLoaded} 
              className="settings-issues-loader" />
          </div>
        </div>
      </section>

      {/* Add other settings sections as needed */}
      {/*
      <section className="settings-section">
        <h3>Other Settings</h3>
        <p>Configure other application settings here.</p>
      </section>
      */}

    </div>
  );
};

export default Settings;
